export const DEFAULT_EDUCATIONAL_CARD_CONTENT =
  "Text inside angle brackets, such as “<Episode Title>”, pulls in content from your RSS feed. They update with each episode, but nothing displays if an item isn't found in your feed. All other text stays the same for each video.";
